// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AvatarMenu_avatar__32SdH","userName":"AvatarMenu_userName__3a_Q-"};